
function downloadException (message) {
  this.message = message;
  this.name = 'downloadException';
}

module.exports.downloadException = downloadException;
